import { SiteHeader } from "@/components/site-header"
import { LayoutDashboardIcon, TrendingUpIcon, AreaChartIcon, SidebarIcon, LogOutIcon } from "lucide-react"

const sections = [
  {
    icon: <LayoutDashboardIcon className="size-5" />,
    title: "Indicadores KPI",
    content: [
      {
        term: "Viajes Confirmados",
        desc: "Total de viajes con estado confirmado en el período. El badge muestra la variación porcentual respecto al período anterior.",
      },
      {
        term: "Cargas Confirmadas",
        desc: "Cantidad de cargas asignadas y confirmadas. Un valor negativo indica caída en la captación de cargas.",
      },
      {
        term: "Choferes Activos",
        desc: "Choferes que registraron actividad en el período. Refleja la disponibilidad operativa de la flota.",
      },
      {
        term: "Crecimiento en Cargas Despachadas",
        desc: "Tasa de crecimiento de cargas efectivamente despachadas. Indicador general de la eficiencia operativa.",
      },
    ],
  },
  {
    icon: <AreaChartIcon className="size-5" />,
    title: "Gráfico Viajes vs Cargas",
    content: [
      {
        term: "Filtros de tiempo",
        desc: "Podés ver los últimos 7 días, 30 días o 3 meses usando los botones en la parte superior derecha del gráfico.",
      },
      {
        term: "Series",
        desc: "El gráfico compara Viajes (área superior) y Cargas (área inferior) apiladas. Los viajes siempre son iguales o mayores que las cargas, ya que un viaje puede transportar múltiples cargas. Pasá el mouse sobre el gráfico para ver los valores exactos de cada día.",
      },
    ],
  },
  {
    icon: <SidebarIcon className="size-5" />,
    title: "Navegación",
    content: [
      {
        term: "Sidebar",
        desc: "Usá el menú lateral para moverte entre Dashboard, Documentación y Changelog. En pantallas pequeñas podés cerrarlo con el ícono de hamburguesa.",
      },
      {
        term: "Documentación",
        desc: "Accedé a las guías disponibles según tu rol. Los admins ven guías de administración además de la guía del operador.",
      },
      {
        term: "Changelog",
        desc: "Historial de cambios del sistema ordenado por versión.",
      },
    ],
  },
  {
    icon: <LogOutIcon className="size-5" />,
    title: "Sesión",
    content: [
      {
        term: "Cerrar sesión",
        desc: "Hacé click en tu nombre en la parte inferior del sidebar y seleccioná 'Cerrar sesión'. La sesión se invalida en el servidor.",
      },
      {
        term: "Expiración",
        desc: "Las sesiones duran 8 horas. Al vencer, serás redirigido automáticamente a la pantalla de login.",
      },
    ],
  },
]

export default function HelpPage() {
  return (
    <>
      <SiteHeader title="Ayuda" />
      <div className="flex flex-1 flex-col px-4 py-6 lg:px-6">
        <div className="max-w-3xl space-y-8">
          <p className="text-sm text-muted-foreground">
            Guía de uso del Sistema de Central de Control y Reconciliación (CDC-SCCR).
          </p>

          {sections.map((section) => (
            <div key={section.title}>
              <div className="flex items-center gap-2 mb-4">
                <span className="text-foreground">{section.icon}</span>
                <h2 className="text-base font-semibold">{section.title}</h2>
              </div>
              <div className="space-y-3 pl-7 border-l-2 border-border">
                {section.content.map((item) => (
                  <div key={item.term} className="space-y-0.5">
                    <p className="text-sm font-medium">{item.term}</p>
                    <p className="text-sm text-muted-foreground">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
